<template lang="html">
  <div class="bill-table-wrapper" v-loading="tableLoading">
    <el-table :data="tableData" border style="width: 100%">
      <el-table-column fixed="left"  prop="" label="操作" align="center">
        <template slot-scope="scope">
          <span class="link-url link-url-left" @click="showDetail(scope.row)"
            >详情</span
          >
        </template>
      </el-table-column>
      <el-table-column width="240" prop="runningNo" label="流水号" align="center">
      </el-table-column>
      <el-table-column prop="totalMoney" label="金额" align="center">
      </el-table-column>
      <el-table-column prop="method" label="方式" align="center">
        <template slot-scope="scope">
          {{
            {
              0: "油卡",
              1: "网银",
              2: "现金",
              3: "支付宝",
              4: "微信",
              5: "冲账",
              6: "到付"
            }[scope.row.method]
          }}
        </template>
      </el-table-column>
      <el-table-column prop="" label="时间" align="center">
        <template slot-scope="scope">
          {{ scope.row.createTime | timeFormat }}
        </template>
      </el-table-column>
      <el-table-column prop="receiptAndPaymentType" label="类型" align="center">
      </el-table-column>
    </el-table>
    <div class="table-page-wrapper">
      <el-pagination
        layout="prev, pager, next"
        :total="total"
        :current-page="page"
        :hide-on-single-page="true"
        @current-change="currentChange"
      >
      </el-pagination>
    </div>
    <!-- 详情弹窗 -->
    <detail-dialog :dialogVisible.sync="detailVisible" :details="details" />
  </div>
</template>

<script>
import detailDialog from "./components/detailDialog";
export default {
  props: {
    ruleForm: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      tableData: [],
      total: 0,
      page: 1,
      tableLoading: true,
      detailVisible: false,
      details: {},
      billNo: this.$route.query.billNo
    };
  },
  computed: {},
  created() {
    this.getDataList();
  },
  methods: {
    /**
     * [getDataList description]
     * @param  {[type]}  type === true [表示是父组件调用]
     * @param  {[type]}  type === false [表示当前组件调用]
     */
    async getDataList(type) {
      type && (this.page = 1);
      this.tableLoading = true;
      let searchData = this.$clearEmptyParams(this.ruleForm);
      let bool = !!Object.keys(searchData).length;
      let {
        data: { list, count }
      } = await this.$http.get("/shipper/order-shipper/bill-turnover-list", {
        params: {
          page: this.page,
          ...(bool && { searchData }),
          ...(this.billNo && { billNo: this.billNo })
        }
      });
      this.tableData = list;
      this.total = count;
      this.tableLoading = false;
    },
    currentChange(val) {
      this.page = val;
      this.getDataList();
    },
    showDetail(row) {
      this.details = row;
      this.detailVisible = true;
    }
  },
  watch: {
    "$route.query"(newVal) {
      this.billNo = newVal.billNo;
      this.getDataList();
    }
  },
  components: {
    detailDialog
  }
};
</script>

<style lang="scss" scoped>
.bill-table-wrapper {
  min-height: calc(100vh - 450px);
  .table-page-wrapper {
    padding-top: 14px;
    display: flex;
    flex-direction: row-reverse;
  }
  .link-url-left {
    margin-right: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/personal/flowingWater/components/flowingWaterTable/index.vue